<template>
  <UModal>
    <template #header="{ close }">
      <div class="flex justify-between items-center w-full">
        <h3 class="text-lg font-semibold">🎉 {{ $t('Added to cart') }}</h3>
        <UButton icon="i-heroicons-x-mark" variant="ghost" color="neutral" size="xs" @click="close" />
      </div>
    </template>
 <template #body>

      <div class="flex items-center gap-4">
        <div>
          <img v-if="product.images.length" :src="product.images[0]!.url" :alt="product.name" class="w-24 h-24 object-cover rounded" />
          <img v-else src="/img/placeholder.jpg" alt="" class="w-24 h-24 object-cover rounded" />
        </div>

        <div class="flex flex-col justify-between">
          <div>
            <h4 class="text-md font-semibold">{{ product.name }}</h4>
            <ProductVariantSummary :summary="variant.summary" class="mt-1" />
            <PriceCompare :price="product.price" :oldPrice="product.regularPrice" class="mt-2" />
          </div>
        </div>
        <div class="ml-auto text-sm text-gray-500">
          <i18n-t keypath="{n} items">
            <template #n>{{ quantity }}</template>
          </i18n-t>
        </div>
      </div>
    </template>

      <template #footer="{ close }">
          <UButton block size="lg" variant="outline" @click="close">
            {{ $t('Continue shopping') }}
          </UButton>
          <UButton block size="lg" variant="solid" :to="$localePath({ name: 'cart' })">
            {{ $t('View cart') }}
          </UButton>
      </template>
    </UModal>
</template>
<script setup lang="ts">
import type { NewCartItem } from '~/types';
import PriceCompare from './PriceCompare.vue';
import ProductVariantSummary from './ProductVariantSummary.vue';

const {
  item
} =defineProps<{
  item: NewCartItem
}>()

const {
  product,
  variant,
  quantity
} = item
</script>
